export class ApiError<TResponse = unknown> extends Error {
  public readonly status: number;
  public readonly response: TResponse | undefined;

  // status = 0 means no HTTP response (network error, timeout, CORS)
  constructor(message: string, status = 0, response?: TResponse) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.response = response;
  }
}
